(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["carmona-restock-button"] && !Shopify.designMode) return;
  try {
    document.addEventListener('keydown',function(event){const button=event.target.closest('.carmona-restock .frcp-wishlist-btn');if(button&&(event.key==='Enter'||event.key===' ')){event.preventDefault();button.click();}});
document.addEventListener('frcp.wishlist.installed',function(){if(window.frcp&&frcp.wishlist&&frcp.wishlist.attachOnCollection)frcp.wishlist.attachOnCollection();},{once:true});
  } catch(e) { console.error(e); }
})();

})();
